import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchProduct, fetchItems, deleteProduct, editProduct, editItem, clearProductsErrors } from '../actions/';
import autoBind from 'react-autobind';
import { fetchOptions, fetchOptionGroups } from '../actions'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditProduct from '../components/products/EditProduct';
import Alert from '../components/home/Alert';
import PreviewData from '../components/products/Common/PreviewData'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import DialogModal from '../components/home/DialogModal';
import FontIcon from 'material-ui/FontIcon';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';
import Checkbox from 'material-ui/Checkbox';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  product: PropTypes.object,
  products: PropTypes.object,
  productId: PropTypes.string.isRequired,
  error: PropTypes.any,
  options: PropTypes.any,
  optiongroups: PropTypes.any,
  query: PropTypes.object.isRequired,
  items: PropTypes.array,
  itemsMeta: PropTypes.object,
  router: PropTypes.object,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}
const plusIconDropszoneSyle = {
  height: '20px',
  width: '20px',
  border: 'none'
}
const tableStyles = {
  stripedRows: true,
  displaySelectAll: false,
  adjustForCheckbox: false,
  selectable: false,
  displayRowCheckbox: false,
};
const styles = {
  floatingLabelStyle: {
    color: cyan900,
  },
  inputStyle: {
    marginRight: '1%',
  },
  inputStyleURL: {
    marginRight: '1%',
    width: '100%'
  },
};
const authPage = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
};
const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)

class ProductEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      newAltImage: { displayOrder: 0, url: '' },
      alertMessage: '',
      edited: false,
      newOptionGroup: {},
      itemToDelete: 0,
      altImageToDelete: 0,
      openDeleteConfirmation: false,
      productOptionItems: [],
      viewRedirect: false,
      selectedPreview: {},
      useNewPreview: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const query = this.props.query;
    const router = this.props.router;
    if (!query.page) {
      query.page = 1;
      query.productId = this.props.productId;
      router.push({ pathname: location.pathname, query });
    }
    this.props.dispatch(fetchItems(query));
    this.props.dispatch(fetchOptions({ limit: 1000 }));
    this.props.dispatch(fetchOptionGroups({ limit: 1000 }));
    this.props.dispatch(fetchProduct(this.props.productId));
  }
  componentWillReceiveProps(nextProps) {
    const product = nextProps.product;
    const nullOption = { name: '', groupName: '' };
    const productOptionItems = [];
    const addItem = (item) => {
      const option = _.find(product.optionItems, { itemId: item.id }) || nullOption;
      const optionItem = {
        name: option.name,
        groupName: option.groupName,
        itemId: item.id,
        itemName: item.name,
        itemSku: item.sku,
        isDefault: option.isDefault || false,
      };
      productOptionItems.push(optionItem);
    };

    if (product && nextProps.items) {
      _.each(nextProps.items, addItem);
    }
    const nextState = { product };

    if (nextProps.error) {
      _.merge(nextState, {
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.product && !nextProps.error && this.state.edited) {
      _.merge(nextState, {
        alertOpen: true,
        alertMessage: 'Product edited successfully!',
        error: false,
      });
    }
    this.setState(nextState);
    this.setState({ productOptionItems });
  }
  openDeleteConfirmation(type, key) {
    if (type === 'altImages') {
      this.setState({
        openDeleteConfirmation: true,
        altImageToDelete: key,
      });
    }
    if (type === 'itemToDelete') {
      this.setState({
        openDeleteConfirmation: true,
        itemToDelete: key,
      });
    }
  }
  handleChange(e) {
    const product = this.props.product;
    if (e.target.type === 'checkbox') {
      _.set(product, e.target.name, e.target.checked);
    } else {
      _.set(product, e.target.name, e.target.value);
    }
    this.setState({
      product,
      edited: true,
    });
  }
  handlePreviewDataChange(e) {
    console.log('HAndle preview Data change', e.target.name, e.target.value)
    const product = this.props.product;
    if (e.target.type === 'checkbox') {
      _.set(product.preview, e.target.name, e.target.checked);
    } else {
      console.log('updating Textfield', e.target.name, e.target.value)
      _.set(product.preview, e.target.name, e.target.value);
    }
    this.setState({
      product,
      edited: true,
    });
  }
  handleCloseDeleteConfirmation() {
    this.setState({
      openDeleteConfirmation: false,
      altImageToDelete: 0,
      itemToDelete: 0,
    });
  }
  handleNewImageChange(e) {
    const nextState = this.state.newAltImage;
    nextState.url = e.target.value;
    this.setState({
      newAltImage: nextState,
    });
  }
  handleDefaultChange(e, itemId) {
    var new_product = this.props.product;
    var new_optionItems = this.props.product.optionItems;
    var new_productOptionItems = this.state.productOptionItems;
    new_product.defaultItemId = itemId;
    new_optionItems = _.forEach(new_product.optionItems, (item, index) => {
      new_optionItems[index].isDefault = (item.itemId === itemId || item.options.some(o => o.itemId === itemId)) ? true : false
      // new_optionItems[index].isDefault = (item.itemId===itemId) ? true : false
    });
    new_productOptionItems = _.forEach(new_productOptionItems, (item, index) => {
      new_productOptionItems[index].isDefault = (item.itemId === itemId) ? true : false
    });
    // new_product.optionItems = new_optionItems
    new_product.optionItems = new_productOptionItems
    this.setState({
      productOptionItems: new_productOptionItems,
      product: new_product,
    });
  }
  handleAddImageSave() {
    const product = this.props.product;
    const newImage = this.props.product.newAltImage;
    if (newImage.url === '') { return; }
    newImage.displayOrder = product.altImages.length + 1;
    product.altImages.push(newImage);
    const nullImage = { displayOrder: 0, url: '' };
    this.setState({ newAltImage: nullImage });
    //this.props.dispatch(editProduct(product));
  }
  handleDelete() {
    const product = this.props.product;
    let productOptionItems = this.state.productOptionItems;
    if (this.state.itemToDelete > 0) {
      const deleteItem = _.find(productOptionItems, { itemId: this.state.itemToDelete });
      const updateItem = { id: deleteItem.itemId, name: deleteItem.itemName, sku: deleteItem.itemSku, productId: 0 };
      product.optionItems = _.pullAllBy(product.optionItems, [{ itemId: this.state.itemToDelete }], 'itemId');
      productOptionItems = _.pullAllBy(productOptionItems, [{ itemId: this.state.itemToDelete }], 'itemId');
      const defaultIndex = _.findIndex(product.optionItems, 'isDefault');
      if (defaultIndex === -1 && product.optionItems.length > 0) {
        productOptionItems[0].isDefault = product.optionItems[0].isDefault = true;
        product.defaultItemId = product.optionItems[0].itemId;
      }
      this.setState({ product });
      this.setState({ productOptionItems });
      this.props.dispatch(editItem(updateItem));
      this.handleCloseDeleteConfirmation();
    }
    if (this.state.altImageToDelete > 0) {
      product.altImages = _.pullAllBy(product.altImages, [{ displayOrder: this.state.altImageToDelete }], 'displayOrder');
      product.altImages = _.orderBy(_.get(product, 'altImages'), 'displayOrder', 'asc');
      product.altImages.forEach((image, i) => { product.altImages[i].displayOrder = i + 1; });
      this.props.dispatch(editProduct(product));
      this.handleCloseDeleteConfirmation();
    }
  }
  handleSwatchDisplayOrder(option, direction) {
    var new_optionItems = this.state.product.optionItems
    // handle case where options have no position:
    const thisIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { name: option.name }))
    const oldNum = option.position || thisIndex + 1
    const newNum = oldNum + direction
    if (oldNum && newNum) {
      var oldIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { position: newNum, groupName: option.groupName }))
      if (oldIndex === -1) {
        oldIndex = thisIndex + direction
      }
      new_optionItems[thisIndex].position = newNum
      new_optionItems[oldIndex].position = oldNum
      var new_product = _.clone(this.state.product)
      new_product.optionItems = new_optionItems
      this.setState({ product: new_product })
    }
  }
  handleImageDisplayOrder(imageOrder, direction) {
    const product = this.props.product;
    const altImages = _.clone(product.altImages);
    const group = _.find(altImages, { displayOrder: imageOrder });
    const currentPosition = group.displayOrder;
    if (currentPosition === 1 && direction === 'up' ||
      currentPosition === altImages.length && direction === 'down' ||
      altImages.length === 1) {
      return;
    }
    let nextPosition;
    if (direction === 'up') {
      nextPosition = currentPosition - 1;
    } else {
      nextPosition = currentPosition + 1;
    }
    const group2 = _.find(altImages, { displayOrder: nextPosition });
    group.displayOrder = nextPosition;
    group2.displayOrder = currentPosition;
    product.altImages = altImages;
    product.attributes = product.attributes !== null ? `{${product.attributes.toString()}}` : ''
    this.props.dispatch(editProduct(product));
  }
  deleteProduct(productId) {
    const products = this.props.products;
    products.delete = true;
    this.setState({ products });
    this.props.dispatch(deleteProduct(productId));
    browserHistory.push('/products?page=1');
  }
  saveEditProduct(product) {
    this.setState({
      edited: true,
    })
    const pProduct = product;
    pProduct.optionItems.map((option) => {
      delete option.itemName
      delete option.itemSku
    })
    pProduct.preview = this.state.useNewPreview ? this.state.selectedPreview.preview : product.preview
    pProduct.preview.portrait.map((p) => {
      return {
        img: p.img,
        x: p.x,
        y: p.y,
        width: p.width,
        height: p.height,
        angle: p.angle,
        index: p.index,
        z: p.z,
        zoomedOverlay: p.zoomedOverlay,
        zoomedX: p.zoomedX,
        zoomedY: p.zoomedY,
        zoomedWidth: p.zoomedWidth,
        zoomedHeight: p.zoomedHeight,
      }
    })
    pProduct.preview.landscape.map((p) => {
      return {
        img: p.img,
        x: p.x,
        y: p.y,
        width: p.width,
        height: p.height,
        angle: p.angle,
        index: p.index,
        z: p.z,
        zoomedOverlay: p.zoomedOverlay,
        zoomedX: p.zoomedX,
        zoomedY: p.zoomedY,
        zoomedWidth: p.zoomedWidth,
        zoomedHeight: p.zoomedHeight,
      }
    })
    pProduct.tagline = (product.tagline === null) ? '' : product.tagline;
    pProduct.category = (product.category === null) ? '' : product.category;
    pProduct.attributes = pProduct.attributes !== null ? `${pProduct.attributes.toString()}` : ''
    this.props.dispatch(editProduct(pProduct));
  }
  navigateToView(location) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editProduct(location));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearProductsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/products/view/${this.props.product.id}`);
      } else {
        browserHistory.push('/products?page=1');
      }
    }
  }
  handleChangeOptionGroupName(optionName, i) {
    var new_optionGroups = this.state.product.optionGroups
    var new_product = this.state.product
    // first check if optionGroup[i] exists
    if (new_optionGroups[i] && new_optionGroups[i].name) { // now update name
      const oldOptionName = new_optionGroups[i].name
      new_optionGroups[i].name = optionName;
      // also update all existing options...
      var new_options = this.props.product && this.props.product.optionItems
      new_options.forEach((opt, i) => {
        if (opt.groupName === oldOptionName) new_options[i].groupName = optionName
      })
      new_product.optionItems = new_options
    } else { // otherwise add it
      const new_option = { name: optionName, position: i + 1 }
      new_optionGroups.push(new_option)
    }
    // now update state
    new_product.optionGroups = new_optionGroups
    this.setState({ product: new_product })
  }
  handleResetProductOptions() {
    var new_product = this.state.product
    const { productOptionItems } = this.state
    new_product.optionItems = []
    new_product.optionGroups = []
    var new_productOptionItems = productOptionItems.map(item => {
      var thisItem = item
      thisItem.name = ''
      thisItem.groupName = ''
      thisItem.isDefault = false
      return thisItem
    })
    this.setState({ product: new_product, productOptionItems: new_productOptionItems })
  }
  handleChangeOptionItemName(optionItem, optionGroupName, new_name) {
    const { optionGroups } = this.state.product
    var new_optionItems = this.state.product.optionItems
    // first check if single option product (so far) or multi-options
    if (optionGroups.length === 1) { // --------------------------------------------- single option product
      console.log('--- single option product ---')
      // now check if new option or change to existing
      if (new_optionItems.some(item => item.itemId === optionItem.itemId)) { // -- existing option
        // change that one option
        const index = _.indexOf(new_optionItems, _.find(new_optionItems, { itemId: optionItem.itemId }));
        console.log('changing optionItems[' + index + ']...')
        new_optionItems[index].name = new_name
      } else { // --------------------------------------------------------------- new option
        // append the new option
        const new_optionItem = {
          name: new_name,
          groupName: optionGroups[0].name,
          itemId: optionItem.itemId,
          position: new_optionItems.length + 1
        }
        console.log('new_optionItem: ', new_optionItem)
        new_optionItems.push(new_optionItem)
      }
    } else { // ================================================================= multi-option product
      console.log('=== multi-option product ===')
      // find previous option name so we can remove...
      const groupOptions = new_optionItems.filter(opt => opt.groupName === optionGroupName) // e.g. all COLOR options
      const altGroupOptions = new_optionItems.filter(opt => opt.groupName !== optionGroupName) // e.g. all SIZE options
      console.log('groupOptions: ', groupOptions)
      console.log('altGroupOptions: ', altGroupOptions)
      // if last option had same id...otherwise, search option.options array
      var lastOpt = groupOptions.find(opt => opt.itemId === optionItem.itemId) || groupOptions.find(opts => opts.options.some(o => o.itemId === optionItem.itemId))
      // if lastOpt then remove old option....
      if (lastOpt) {
        console.log('LAST OPTION: ', lastOpt)
        const index = _.indexOf(new_optionItems, _.find(new_optionItems, { itemId: lastOpt.itemId, groupName: optionGroupName }));
        var new_subOptions = lastOpt.options
        const subIndex = _.indexOf(new_subOptions, _.find(new_subOptions, { itemId: optionItem.itemId }));
        new_subOptions.splice(subIndex, 1) // remove old option
        new_optionItems[index].options = new_subOptions
        if (new_subOptions.length === 0) new_optionItems.splice(index, 1) // remove whole option since empty now
      }
      // var altOptionName = new_subOptions[subIndex].name
      var lastAltOpt = altGroupOptions.find(opt => opt.itemId === optionItem.itemId) || altGroupOptions.find(opts => opts.options.some(o => o.itemId === optionItem.itemId))

      /****************************************************************
       * THERE ARE 4 POSSIBLE SCENARIOS:
       *  1. this option does NOT exist, alt option does NOT exist
       *     -- insert new option (e.g. 10x10)
       *  2. this option does NOT exist, alt option exists
       *     -- insert new option (e.g. Gold)
       *     -- add this option to alt-sub-options (e.g. add Gold to 10x10)
       *     -- add alt-option to this sub-options (e.g. add 10x10 to Gold)
       *  3. this option exists, alt option does NOT exist
       *     -- put an option in even with wrong name as a PLACEHOLDER ***
       *  4. this option exists, alt option exists (e.g. add 10x10 to 10x10) ***
       *     -- add this option to alt-sub-options (e.g. add Silver to 10x10)
       *     -- add alt-option to this sub-options (e.g. add 10x10 to Silver)
       ****************************************************************/

      // check if this option does NOT exist... (SCENARIO 2 or 4)
      if (!groupOptions.find(opt => opt.name === new_name)) {
        // --------------------------------------------------- Insert new option
        const new_sub_options = (lastAltOpt) ? [{ name: lastAltOpt.name, itemId: optionItem.itemId }] : []
        // no, append new option
        const new_option = {
          name: new_name,
          groupName: optionGroupName,
          itemId: optionItem.itemId,
          position: new_optionItems.length + 1,
          options: new_sub_options
        }
        new_optionItems.push(new_option)
        // --------------------------------------------------- DONE
        if (lastAltOpt) { // if we have an alternate option (SCENARIO 2)
          console.log('SCENARIO 2 -- this option does NOT exist, alt option exists')
          // --------------------------------------------------- Add this option to alt-sub-options
          console.log('LAST ALT OPTION: ', lastAltOpt)
          const altIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { itemId: lastAltOpt.itemId, groupName: lastAltOpt.groupName }));
          var new_altSubOptions = lastAltOpt.options
          const subAltIndex = _.indexOf(new_altSubOptions, _.find(new_altSubOptions, { itemId: optionItem.itemId }));
          if (subAltIndex > -1) {
            new_altSubOptions[subAltIndex].name = new_name
            new_optionItems[altIndex].options = new_altSubOptions
          } else {
            new_altSubOptions.push({ name: new_name, itemId: optionItem.itemId })
            new_optionItems[altIndex].options = new_altSubOptions
          }
          console.log('UPDATING ALT OPTIONS ', new_optionItems[altIndex])
        } else {
          console.log('SCENARIO 1 -- this option does NOT exist, alt option does NOT exist')
        }
        // --------------------------------------------------- DONE
      } else { // option already exists (SCENARIO 4 or 3)
        if (lastAltOpt) { // if we have an alternate option (SCENARIO 4)
          console.log('SCENARIO 4 -- this option exists, alt option exists')
          // --------------------------------------------------- Add item to alt-sub-options
          console.log('LAST ALT OPTION: ', lastAltOpt)
          const altIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { itemId: lastAltOpt.itemId, groupName: lastAltOpt.groupName }));
          var new_altSubOptions = lastAltOpt.options
          const subAltIndex = _.indexOf(new_altSubOptions, _.find(new_altSubOptions, { itemId: optionItem.itemId }));
          if (subAltIndex > -1) {
            new_altSubOptions[subAltIndex].name = new_name
            new_optionItems[altIndex].options = new_altSubOptions
          } else {
            new_altSubOptions.push({ name: new_name, itemId: optionItem.itemId })
            new_optionItems[altIndex].options = new_altSubOptions
          }
          console.log('UPDATING ALT OPTIONS ', new_optionItems[altIndex])
          const thisIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { name: new_name }));
          var thisOptionArray = new_optionItems[thisIndex].options
          thisOptionArray.push({ name: lastAltOpt.name, itemId: optionItem.itemId })
          new_optionItems[thisIndex].options = thisOptionArray
          console.log('UPDATING EXISTING OPTION ', new_optionItems[thisIndex])
          // --------------------------------------------------- DONE
        } else {
          console.log('SCENARIO 3 -- this option exists, alt option does NOT exist')
          // we need to put an option in even with wrong name as a placeholder
          const thisIndex = _.indexOf(new_optionItems, _.find(new_optionItems, { name: new_name }));
          var thisOptionArray = new_optionItems[thisIndex].options
          thisOptionArray.push({ name: new_name, itemId: optionItem.itemId })
          new_optionItems[thisIndex].options = thisOptionArray
          console.log('UPDATING EXISTING OPTION (PLACEHOLDER) ', new_optionItems[thisIndex])
        }
      }
    }
    console.log('new optionItems: ', new_optionItems)
    var new_product = _.clone(this.state.product)
    new_product.optionItems = new_optionItems
    // now update state
    const isPrimary = optionGroups[0].name === optionGroupName
    console.log('isPrimary: ', isPrimary)
    if (isPrimary) {
      // update productOptions, too
      var new_productOptionItems = this.state.productOptionItems
      const thisProductOptionItemIndex = _.indexOf(new_productOptionItems, _.find(new_productOptionItems, { itemId: optionItem.itemId }))
      new_productOptionItems[thisProductOptionItemIndex].name = new_name
      new_productOptionItems[thisProductOptionItemIndex].groupName = optionGroupName
      this.setState({ product: new_product, productOptionItems: new_productOptionItems })
    } else {
      this.setState({ product: new_product })
    }
  }
  renderProductImages() {
    const iconStyles = {
      marginRight: 24,
    };
    const productImages = _.orderBy(_.get(this, 'props.product.altImages'), 'displayOrder', 'asc');
    if (!productImages) { return ''; }
    return productImages.map((image, i) =>
      <TableRow key={i}>
        <TableRowColumn style={{ width: '100px' }} key={`${i}`}>{image.displayOrder}</TableRowColumn>
        <TableRowColumn key={`${i}`}>{image.url}</TableRowColumn>
        <TableRowColumn style={{ width: '200px' }} key={`${i}`}>
          <FontIcon
            className="fa fa-caret-up"
            style={iconStyles}
            onClick={() => this.handleImageDisplayOrder(image.displayOrder, 'up')}
          />
          <FontIcon
            className="fa fa-caret-down"
            style={iconStyles}
            onClick={() => this.handleImageDisplayOrder(image.displayOrder, 'down')}
          />
          <FontIcon
            className="fa fa-trash"
            style={iconStyles}
            onClick={() => this.openDeleteConfirmation('altImages', image.displayOrder)}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  renderProductOptionsItems() {
    const optionGroups = this.state.product && this.state.product.optionGroups
    const primaryOptionGroupName = optionGroups && optionGroups[0] && optionGroups[0].name
    const secondaryOptionGroupName = optionGroups && optionGroups[1] && optionGroups[1].name
    const optionGroupSelect = _.map(this.props.optiongroups, p => <MenuItem value={p.name} key={p.id} primaryText={p.name} />);
    // const optionGroupSelect = _.map(optionGroups, p => <MenuItem value={p.name} key={p.id} primaryText={p.name} />);
    return (
      <Table selectable={false} wrapperStyle={{ overflow: 'inherit' }}>
        <TableHeader
          displaySelectAll={tableStyles.displaySelectAll}
          adjustForCheckbox={tableStyles.adjustForCheckbox}
        >
          <TableRow
            selectable={tableStyles.selectable}
          >
            <TableHeaderColumn style={{ width: '30%' }}>Name</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '120px' }}>SKU</TableHeaderColumn>
            <TableHeaderColumn>
              <SelectField
                name="name"
                style={{ verticalAlign: 'bottom' }}
                value={primaryOptionGroupName}
                onChange={(event, index, value) => this.handleChangeOptionGroupName(value, 0)}
              >
                {optionGroupSelect}
              </SelectField>
            </TableHeaderColumn>
            <TableHeaderColumn>
              <SelectField
                name="groupName"
                style={{ verticalAlign: 'bottom' }}
                value={secondaryOptionGroupName}
                onChange={(event, index, value) => this.handleChangeOptionGroupName(value, 1)}
              >
                {optionGroupSelect}
              </SelectField>
            </TableHeaderColumn>
            <TableHeaderColumn style={{ width: '80px' }}>Default</TableHeaderColumn>
            <TableHeaderColumn style={{ width: '80px' }}>Delete</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody
          stripedRows={tableStyles.stripedRows}
          displayRowCheckbox={tableStyles.displayRowCheckbox}
        >
          {this.renderProductOptionsItemsTableRows(primaryOptionGroupName, secondaryOptionGroupName)}
        </TableBody>
      </Table>
    )
  }
  renderProductOptionsItemsTableRows(primaryOptionGroupName, secondaryOptionGroupName) {
    const iconStyles = {
      marginRight: 24,
    };
    const productOptionItems = this.state.productOptionItems;
    const primaryOptions = this.props.product && this.props.product.optionItems.filter(opt => opt.groupName === primaryOptionGroupName)
    //console.log('primaryOptions: ', primaryOptions)
    const secondaryOptions = this.props.product && this.props.product.optionItems.filter(opt => opt.groupName === secondaryOptionGroupName)
    //console.log('secondaryOptions: ', secondaryOptions)
    const optionSelect = _.map(this.props.options, c => <MenuItem value={c.name} key={c.id} primaryText={c.name} />);
    if (!productOptionItems) { return ''; }
    return productOptionItems.map(optionItem => {
      if (secondaryOptionGroupName && primaryOptions.find(o => o.hasOwnProperty("options"))) { // multi-option product

        const thisPrimaryOption = primaryOptions.find(opt => opt.options.some(ops => ops.itemId === optionItem.itemId))
        var thisPrimaryOptionName = thisPrimaryOption && thisPrimaryOption.name

        const thisSecondaryOption = secondaryOptions.find(opt => opt.options.some(ops => ops.itemId === optionItem.itemId))
        var thisSecondaryOptionName = thisSecondaryOption && thisSecondaryOption.name
      } else { // single-option product
        var thisPrimaryOptionName = optionItem.name
        var thisSecondaryOptionName = null
      }
      return (
        <TableRow key={optionItem.itemId}>
          <TableRowColumn key={`${optionItem.itemId}_itemName`} style={{ width: '30%' }}>{optionItem.itemName}</TableRowColumn>
          <TableRowColumn key={`${optionItem.itemId}_sku`} style={{ width: '120px' }}>{optionItem.itemSku}</TableRowColumn>
          <TableRowColumn key={`${optionItem.itemId}_groupName`}>
            <SelectField
              name="name"
              style={{ verticalAlign: 'bottom' }}
              value={thisPrimaryOptionName}
              onChange={(event, index, value) => this.handleChangeOptionItemName(optionItem, primaryOptionGroupName, value)}
            >
              {optionSelect}
            </SelectField>
          </TableRowColumn>
          <TableRowColumn key={`${optionItem.itemId}_name`}>
            <SelectField
              name="name"
              style={{ verticalAlign: 'bottom' }}
              value={thisSecondaryOptionName}
              onChange={(event, index, value) => this.handleChangeOptionItemName(optionItem, secondaryOptionGroupName, value)}
            >
              {optionSelect}
            </SelectField>
          </TableRowColumn>
          <TableRowColumn key={optionItem.itemId} style={{ width: '80px' }}>
            <ul>
              <li>
                <Checkbox
                  defaultChecked={optionItem.isDefault}
                  name="defaultItemId"
                  onCheck={(e) => this.handleDefaultChange(e, optionItem.itemId)}
                />
              </li>
            </ul>
          </TableRowColumn>
          <TableRowColumn key={optionItem.itemId} style={{ width: '80px' }}>
            <FontIcon
              className="fa fa-trash"
              style={iconStyles}
              onClick={() => this.openDeleteConfirmation('itemToDelete', optionItem.itemId)}
            />
          </TableRowColumn>
        </TableRow>)
    }
    );
  }
  renderOptions(optionName) {
    const iconStyles = {
      marginRight: 24,
    };
    const theseOptions = this.state.product && this.state.product.optionItems.filter(opt => opt.groupName === optionName)
    const optionItems = _.orderBy(theseOptions, 'position', 'asc');
    const plusIcon = <FontIcon className="fa fa-plus-circle" style={iconStyles} />
    //const swatchUrl = 
    if (!optionItems) { return ''; }
    return optionItems.map((option, i) =>
      <TableRow key={i}>
        <TableRowColumn style={{ width: '100px' }} key={`${i}`}>{option.name}</TableRowColumn>
        <TableRowColumn style={{ width: '100px' }} key={`${i}`}>{option.swatch
          ? <img src={option.swatch} alt={option.name} />
          : null}
        </TableRowColumn>
        <TableRowColumn style={{ width: '50px' }} key={`${i}`}>
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES FROM FILESTACK', res);
                  const thisIndex = _.indexOf(this.state.product.optionItems, _.find(this.state.product.optionItems, { name: option.name }))
                  const targetName = `optionItems[${thisIndex}].swatch`
                  const targetValue = res.filesUploaded[0].url
                  this.handleUpload(targetName, targetValue)
                })
              }).open()
            }}
            style={plusIconDropszoneSyle}>
            <p className="filestack-uplaod">{plusIcon}</p>
          </button>
        </TableRowColumn>
        <TableRowColumn style={{ width: '100px' }} key={`${i}`}>
          <FontIcon
            className="fa fa-caret-up"
            style={iconStyles}
            onClick={() => this.handleSwatchDisplayOrder(option, -1)}
          />
          <FontIcon
            className="fa fa-caret-down"
            style={iconStyles}
            onClick={() => this.handleSwatchDisplayOrder(option, 1)}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  handleUploadedPreviewImage(name, value) {
    const product = this.props.product;
    _.set(product.preview, name, value);
    this.setState({
      product,
      edited: true,
    });
  }
  handleUpload(name, value) {
    const product = this.props.product;
    _.set(product, name, value);
    this.setState({
      product,
      edited: true,
    });
  }
  handleProductOptionSelect(event, index, value) {
    this.setState({
      useNewPreview: true,
      selectedPreview: value
    })
  }
  render() {
    const productPreview = this.state.useNewPreview ? this.state.selectedPreview : this.props.product
    if (!this.state.product) {
      return (<div>Loading...</div>)
    } else {
      const newImageUrl = this.props && this.props.product && this.props.product.newAltImage && this.props.product.newAltImage.url ? this.props.product.newAltImage.url : ""
      const { optionGroups } = this.state.product
      return (
        <div className="products component" style={authPage}>
          <h2>Edit Product</h2>
          <Alert
            alertOpen={this.state.alertOpen}
            alertHandleClose={() => this.alertHandleClose()}
            alertMessage={this.state.alertMessage}
          />
          <div className="content">
            <EditProduct
              product={this.props.product}
              onSave={data => this.saveEditProduct(data)}
              onDelete={data => this.deleteProduct(data)}
              onView={data => this.navigateToView(data)}
            />
          </div>
          <DialogModal
            dialogOpen={this.state.openDeleteConfirmation}
            dialogHandleClose={this.handleCloseDeleteConfirmation}
            dialogHandleSubmit={this.handleDelete}
            dialogTitle="Delete"
            dialogMessage="Do you really want to delete this?"
            dialogActionTitle="Delete"
          />
          <PreviewData
            styles={styles}
            dropzoneStyles={dropzoneStyles}
            product={productPreview}
            handlePreviewDataChange={this.handlePreviewDataChange}
            handleUploadedImage={this.handleUploadedPreviewImage}
            handleChange={this.handleChange}
            client={client}
            handleProductOptionSelect={this.handleProductOptionSelect}
            items={this.props.product.items}
          />
          <h2>More Product Images</h2>
          <div className="content">
            <TextField
              floatingLabelText="New Image Url"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={newImageUrl}
              style={styles.inputStyleURL}
              name="newAltImage.url"
            />
            <button
              className="filestack-button"
              onClick={(e) => {
                e.preventDefault;
                return client.picker({
                  uploadInBackground: false,
                  onUploadDone: ((res) => {
                    console.log('RES FROM FILESTACK', res);
                    const targetName = 'newAltImage.url'
                    const targetValue = res.filesUploaded[0].url
                    this.handleUpload(targetName, targetValue)
                  })
                }).open()
              }}
              style={dropzoneStyles}>
              <p className="filestack-uplaod">Upload "More Product" Image</p>
            </button>
            <br />
            <br />
            <RaisedButton
              label="ADD NEW IMAGE"
              primary
              onClick={this.handleAddImageSave}
            />
            <div style={{ clear: 'left' }}></div>
            <Table selectable={false}>
              <TableHeader
                displaySelectAll={tableStyles.displaySelectAll}
                adjustForCheckbox={tableStyles.adjustForCheckbox}
              >
                <TableRow
                  selectable={tableStyles.selectable}
                >
                  <TableHeaderColumn style={{ width: '100px' }}>Display Order</TableHeaderColumn>
                  <TableHeaderColumn>Image URL</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Actions</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody
                stripedRows={tableStyles.stripedRows}
                displayRowCheckbox={tableStyles.displayRowCheckbox}
              >
                {this.renderProductImages()}
              </TableBody>
            </Table>
          </div>
          <h2>Product Options (Items)</h2>
          <div className="content">
            <p>
              Map a product item to the corresponding option and option group
          </p>
            <br />
            <br />
            <div>
              <RaisedButton
                label="CLEAR OPTIONS"
                primary
                onClick={this.handleResetProductOptions}
              />
            </div>
            {this.renderProductOptionsItems()}
          </div>
          <h2>Option Orders</h2>
          <div className="content">
            <div style={{ clear: 'left' }}></div>
            <div className="row">
              {optionGroups.map(optionGroup => {
                return <div className="col">
                  <Table selectable={false}>
                    <TableHeader
                      displaySelectAll={tableStyles.displaySelectAll}
                      adjustForCheckbox={tableStyles.adjustForCheckbox}
                    >
                      <TableRow
                        selectable={tableStyles.selectable}
                      >
                        <TableHeaderColumn style={{ width: '100px' }}>{optionGroup.name}</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '100px' }}>{this.state.product.optionItems.swatch ? 'Swatch' : null}</TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '150px' }}>Actions</TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody
                      stripedRows={tableStyles.stripedRows}
                      displayRowCheckbox={tableStyles.displayRowCheckbox}
                    >
                      {this.renderOptions(optionGroup.name)}
                    </TableBody>
                  </Table>
                </div>
              })}
            </div>
          </div>
        
          <br />
        </div>
      );
    }
  }
}

ProductEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ProductEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  const product = state.products.product;
  const products = state.products;
  return {
    isAuthenticated: state.auth.isAuthenticated,
    product,
    products,
    productId: ownProps.params.id,
    options: state.options.results,
    optiongroups: state.optiongroups.results,
    error: state.products.error,
    itemsMeta: state.items.meta,
    items: state.items.results,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(ProductEditPage));



// WEBPACK FOOTER //
// ./src/containers/ProductEditPage.js